// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"65343867","309":"79f46939","676":"331c70a8","876":"a380443d"}[chunkId] + ".chunk.js";
};